<script setup>
import {debounce} from "lodash/function";

defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    required: false,
    default: 'Search',
  }
});

const emit = defineEmits(['update:modelValue']);

const clear = () => {
  emit('update:modelValue', '');
}

const onSearchInput = debounce((event) => {
  emit('update:modelValue', event.target.value);
}, 500);
</script>

<template>
  <label class="tw-border tw-border-neutral tw-rounded-lg tw-flex tw-text-black tw-col-span-12 tw-min-h-[50px]">
    <svg-vue
      icon="icons/search"
      class="tw-w-7 tw-min-w-[1.75rem] tw-h-7 tw-my-2 tw-ml-3 tw-text-neutral"
    />
    <input
      :value="modelValue"
      :placeholder="placeholder"
      class="tw-border-0 tw-w-full tw-pl-3 tw-text-lg tw-pr-2 tw-rounded-r-lg tw-text-neutral-900"
      type="text"
      @input="onSearchInput"
    >
    <svg-vue
      v-if="modelValue"
      icon="icons/search-close"
      class="tw-w-7 tw-h-7 tw-my-2 tw-mr-2 tw-text-neutral tw-cursor-pointer"
      @click="clear"
    />
  </label>
</template>
